import {Locale} from "../../Constants/locales";
import {ColourScheme, DarkColourScheme} from "./Common/ColourScheme";

export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';
export const THEME_AUTO = 'auto';
export const THEMES = [THEME_LIGHT, THEME_DARK] as const;
export const INPUT_THEMES = [THEME_LIGHT, THEME_DARK, THEME_AUTO] as const;
export type WidgetStyleTheme = typeof THEMES[number];
export type InputWidgetStyleTheme = typeof INPUT_THEMES[number];

export const CALENDAR_SHOW_PER_DAY_PRICES = 'prices';
export const CALENDAR_SHOW_PER_DAY_CAPACITY = 'capacity';
export const CALENDAR_SHOW_PER_DAY = [CALENDAR_SHOW_PER_DAY_PRICES, CALENDAR_SHOW_PER_DAY_CAPACITY, false] as const;
export type CalendarCellAdditionalInfo = typeof CALENDAR_SHOW_PER_DAY[number];

// #region ConfigurationTypes
export interface BaseWidgetConfiguration {
    id: string,
    locale: Locale,
    instanceId: string,
    inventoryAccess: {
        experiences: string[],
        flexOffers: string[],
    },
    options: {
        previewMode: boolean,
        previewToken: string | false,
        tracking: boolean,
        crashReport: boolean,
        collectTraces: boolean,
        loggingLevel: 'debug' | 'warn' | 'error',
    },
    displaySettings: {
        appointmentList: {
            showCapacity: boolean,
            showPrices: boolean,
        },
        calendar: {
            showPerDay: CalendarCellAdditionalInfo,
        },
    },
    checkoutTheme: string,
    localisation: Partial<Record<Locale, Record<string, string>>>
    themeConfiguration: {
        mode: WidgetStyleTheme,
        light: {
            colours: Partial<ColourScheme>
        },
        dark: {
            colours: Partial<ColourScheme>
        }
    }
};
// #endregion ConfigurationTypes

export type BaseWidgetConfigurationInput = {
    id: string,
    /** @default false */
    locale?: Locale | false,
    options?: Partial<BaseWidgetConfiguration['options']>,
    inventoryAccess?: {
        experiences?: string[],
        flexOffers?: string[],
    },
    displaySettings?: {
        appointmentList?: {
            /** @default false */
            showCapacity?: boolean,
            /** @default false */
            showPrices?: boolean,
        },
        calendar?: {
            /** @default false */
            showPerDay?: CalendarCellAdditionalInfo,
        },
    },
    checkoutTheme?: string,
    localisation?: Partial<Record<Locale, Record<string, string>>>,
    themeConfiguration?: {
        /** @default auto */
        mode?: InputWidgetStyleTheme,
        light?: {
            colours?: Partial<ColourScheme>
        },
        dark?: {
            colours?: Partial<DarkColourScheme>
        }
    }
};
